import React, { useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { WaybillService } from "../../../../services/WaybillService";
import AddnExport from "../../StockManagement/sub-components/Add-Export";
import Search from "../../StockManagement/sub-components/Search";
import TableActions from "../../StockManagement/sub-components/TableActions";
import moment from "moment";

const Returns = () => {
  const navigate = useNavigate();

  const waybillColumns = [
    {
      name: "OrderNumber",
      selector: (row) => row.orderNumber,
    },
    {
      name: "Waybill Number",
      selector: (row) => row.waybillNumber,
    },


    {
      name: "Total Amount",
      selector: (row) => ` GHS ${row.totalAmount}`,
    },
    {
      name: "Comments",
      selector: (row) => `${row.comment}`,
    },
    {
      name: "Date",
      selector: (row) => moment(row.dateCreated).format('YYYY-MM-DD'),
    },
    // {
    //   name: "Active",
    //   selector: (row) =>
    //     row.isActive ? (
    //       <ActivePill>Active</ActivePill>
    //     ) : (
    //       <InactivePill>Inactive</InactivePill>
    //     ),
    // },
    {
      name: "Actions",
      selector: (row) => (
        <div>
          <TableActions
            viewAction={() => navigate(`/dashboard/waybills/returns/${row.returnId}`)}
            noDelete
          />
        </div>
      ),
    },
  ];
  const [waybillReturns,setWaybillReturns] = useState([])
  useEffect(() => {
    handleWaybillReturns();
  }, []);
  const [pending, setPending] = useState(true);
  const handleWaybillReturns = () => {
    WaybillService.GetAllReturns().then((res) => {
      
      setWaybillReturns(...waybillReturns, res);
      setPending(false);
      // console.log(concessions)
      
    });
  };
  const [search,setSearch] = useState("");
  const handleSearch = (event) => {
    setSearch(event.target.value); 
  };

  useEffect(() => {
    console.log(search)
  }, [search]);
  return (
    <div className="w-full">
      <AddnExport />
      <Search placeholder="Search Waybill Returns" />
      <DataTable
        className="w-full rounded rounded-lg"
        columns={waybillColumns}
        data={waybillReturns.filter((item) => {
          if (search === "") {
            return item;
          } else{
           return item.description.toLowerCase().includes(search.toLowerCase())||
           item.orderNumber.toLowerCase().includes(search.toLowerCase())
           
          }
        })}
        progressPending={pending}
        pagination
      />
    </div>
  );
};

export default Returns;

const data = [
  {
    id: 1,
    orderNumber: "order-234tvd",
    numberOfProducts: 13,
    totalAmount: 130,
    isPaid: true,
    driver: "Mensah",
    client: "Yaw",
    manager: "Gaisie",
    supervisor: "Ernest",
    personnel: "Senior Maen",
    amountPaid: 120,
  },
  {
    id: 2,
    orderNumber: "order-234tvd45",
    numberOfProducts: 13,
    totalAmount: 130,
    isPaid: true,
    driver: "Mensah",
    client: "Yaw",
    manager: "Gaisie",
    supervisor: "Ernest",
    personnel: "Senior Maen",
    amountPaid: 120,
  },
  {
    id: 3,
    orderNumber: "order-234t5jvd",
    numberOfProducts: 13,
    totalAmount: 130,
    isPaid: false,
    driver: "Mensah",
    client: "Yaw",
    manager: "Gaisie",
    supervisor: "Ernest",
    personnel: "Senior Maen",
    amountPaid: 120,
  },
];
